import { forwardRef, type SVGProps } from "react";
import { BRANDING } from "../../config/branding";

export interface FairdayLogoProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const FairdayLogo = forwardRef<SVGSVGElement, FairdayLogoProps>(
  ({ color = BRANDING.logo.defaultColor, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        viewBox={BRANDING.logo.viewBox}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Fairday logo"
        className={className}
        {...props}
      >
        {BRANDING.logo.paths.map((path, index) => (
          <path key={`${path.slice(0, 20)}-${index}`} d={path} fill={color} />
        ))}
      </svg>
    );
  }
);

FairdayLogo.displayName = "FairdayLogo";
